<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M0.751,23.979c-0.265,0-0.512-0.142-0.646-0.37c-0.134-0.228-0.138-0.513-0.009-0.745l3.75-6.75
		c0.124-0.223,0.35-0.367,0.605-0.384c0.013-0.001,0.036-0.002,0.058-0.002c0.23,0,0.452,0.112,0.593,0.3l1.521,2.027l5.494-8.727
		c0.014-0.021,0.026-0.039,0.039-0.056c0.162-0.211,0.365-0.387,0.595-0.519V0.729c0-0.414,0.336-0.75,0.75-0.75h7.193
		c0.493,0.002,0.942,0.292,1.147,0.737c0.208,0.436,0.148,0.949-0.156,1.334l-1.028,1.304l1.033,1.307
		c0.303,0.385,0.362,0.899,0.153,1.342c-0.202,0.44-0.651,0.727-1.141,0.729h-6.45V8.55c0.262,0.067,0.509,0.186,0.725,0.352
		c0.139,0.107,0.263,0.231,0.369,0.37c0.014,0.018,0.027,0.036,0.039,0.055l8.502,13.503c0.146,0.231,0.154,0.523,0.022,0.762
		c-0.132,0.239-0.384,0.388-0.657,0.388H0.751z M21.892,22.479l-3.268-5.189l-1.69,1.42c-0.312,0.264-0.712,0.41-1.127,0.41
		c-0.47,0-0.91-0.181-1.239-0.51l-0.643-0.644c-0.046-0.046-0.109-0.072-0.176-0.072c-0.067,0-0.13,0.026-0.177,0.073l-0.641,0.642
		c-0.329,0.329-0.769,0.51-1.239,0.51c-0.415,0-0.816-0.146-1.129-0.412l-1.687-1.418l-3.268,5.189H21.892z M3.837,22.479
		l1.929-3.064l-1.171-1.561l-2.569,4.625H3.837z M11.531,17.56c0.046,0.039,0.103,0.06,0.163,0.06c0.068,0,0.131-0.026,0.177-0.072
		l0.641-0.642c0.331-0.33,0.77-0.512,1.238-0.512s0.907,0.182,1.237,0.511l0.643,0.644c0.046,0.046,0.109,0.071,0.177,0.071
		c0.06,0,0.117-0.021,0.161-0.058l1.85-1.554l-3.679-5.843c-0.023-0.027-0.05-0.052-0.078-0.073
		c-0.11-0.084-0.226-0.102-0.305-0.102c-0.03,0-0.059,0.002-0.088,0.007c-0.013,0.003-0.027,0.006-0.041,0.008
		c-0.065,0.014-0.176,0.056-0.265,0.16l-3.679,5.843L11.531,17.56z M20.229,5.232l-0.857-1.085
		c-0.366-0.468-0.367-1.118-0.002-1.584l0.855-1.084h-5.974v3.753H20.229z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'business-climb-top',
    },
    name: {
      type: String,
      required: false,
      default: 'BusinessClimbTop',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>